/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './pages/editable-subscriptions-page.pug';
import metadata from './metadata.json';
import esPapers from './data/esPapers.json';

export default function register() {
  page('/legal/baseline/edit', render);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    esPapers,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/legals/editable-subscriptions/editableSubscriptions.js